import {Layout, Anchor, Typography} from 'antd';
import React, {useState} from 'react';
import appColors from '../../style/theme';
import Introduction from './Introduction';
import Approvals from './Approvals';
import Challenges from './Challenges';
import Conclusions from './Conclusions';
import Endusers from './Endusers';
import NextSteps from './NextSteps';
import Safety from './Safety';
import UserManual from './UserManual';
import Distribution from './Distribution';
import References from './References';

const {Link} = Anchor;
const {Sider, Content} = Layout;
const Text = Typography;


const handleClick = (e, link) => {
  e.preventDefault();
  console.log(link);
};


const ImplementationLogic = () => {
  const [backI, setBackI] = useState('transparent');
  const [backII, setBackII] = useState('transparent');
  const [backIII, setBackIII] = useState('transparent');
  const [backIV, setBackIV] = useState('transparent');
  const [backV, setBackV] = useState('transparent');
  const [backVI, setBackVI] = useState('transparent');
  const [backVII, setBackVII] = useState('transparent');
  const [backVIII, setBackVIII] = useState('transparent');
  const [backIX, setBackIX] = useState('transparent');
  const [backX, setBackX] = useState('transparent');
  const ChangeAnchor = (key) => {
    console.log(key);
    if (key === '#TeamAdvisors') {
      setBackI(appColors['ColorA']);
      setBackII('transparent');
      setBackIII('transparent');
      setBackIV('transparent');
      setBackV('transparent');
      setBackVI('transparent');
      setBackVII('transparent');
      setBackVIII('transparent');
      setBackIX('transparent');
      setBackX('transparent');
    } else if (key === '#TeamLeadership') {
      setBackI('transparent');
      setBackII(appColors['ColorA']);
      setBackIII('transparent');
      setBackIV('transparent');
      setBackV('transparent');
      setBackVI('transparent');
      setBackVII('transparent');
      setBackVIII('transparent');
      setBackIX('transparent');
      setBackX('transparent');
    } else if (key === '#TeamWL') {
      setBackI('transparent');
      setBackII('transparent');
      setBackIII(appColors['ColorA']);
      setBackIV('transparent');
      setBackV('transparent');
      setBackVI('transparent');
      setBackVII('transparent');
      setBackVIII('transparent');
      setBackIX('transparent');
      setBackX('transparent');
    } else if (key === '#TeamDL') {
      setBackI('transparent');
      setBackII('transparent');
      setBackIII('transparent');
      setBackIV(appColors['ColorA']);
      setBackV('transparent');
      setBackVI('transparent');
      setBackVII('transparent');
      setBackVIII('transparent');
      setBackIX('transparent');
      setBackX('transparent');
    } else if (key === '#TeamHP') {
      setBackI('transparent');
      setBackII('transparent');
      setBackIII('transparent');
      setBackIV('transparent');
      setBackV(appColors['ColorA']);
      setBackVI('transparent');
      setBackVII('transparent');
      setBackVIII('transparent');
      setBackIX('transparent');
      setBackX('transparent');
    } else if (key === '#TeamC') {
      setBackI('transparent');
      setBackII('transparent');
      setBackIII('transparent');
      setBackIV('transparent');
      setBackV('transparent');
      setBackVI(appColors['ColorA']);
      setBackVII('transparent');
      setBackVIII('transparent');
      setBackIX('transparent');
      setBackX('transparent');
    } else if (key === '#TeamEdu') {
      setBackI('transparent');
      setBackII('transparent');
      setBackIII('transparent');
      setBackIV('transparent');
      setBackV('transparent');
      setBackVI('transparent');
      setBackVII(appColors['ColorA']);
      setBackVIII('transparent');
      setBackIX('transparent');
      setBackX('transparent');
    } else if (key === '#TeamEntre') {
      setBackI('transparent');
      setBackII('transparent');
      setBackIII('transparent');
      setBackIV('transparent');
      setBackVI('transparent');
      setBackVII('transparent');
      setBackVIII(appColors['ColorA']);
      setBackIX('transparent');
      setBackX('transparent');
    } else if (key === '#2') {
      setBackI('transparent');
      setBackII('transparent');
      setBackIII('transparent');
      setBackIV('transparent');
      setBackVI('transparent');
      setBackVII('transparent');
      setBackVIII('transparent');
      setBackIX(appColors['ColorA']);
      setBackX('transparent');
    } else if (key === '#3') {
      setBackI('transparent');
      setBackII('transparent');
      setBackIII('transparent');
      setBackIV('transparent');
      setBackVI('transparent');
      setBackVII('transparent');
      setBackVIII('transparent');
      setBackIX('transparent');
      setBackX(appColors['ColorA']);
    }
  };
  return (
    <Layout style={{background: 'transparent'}}>
      <Sider style={{background: 'transparent'}}>
        <Anchor onClick={handleClick} offsetTop={75} onChange={ChangeAnchor} style={{background: 'transparent'}}>
          <Link href='#TeamAdvisors' title={<Content className='ContentAnchor' style={{borderColor: backI}}><Text style={{color: appColors['ColorA'], fontSize: '2.1vh'}}>Introduction</Text></Content>}/>
          <Link href='#TeamLeadership' title={<Content className='ContentAnchor' style={{borderColor: backII}}><Text style={{color: appColors['ColorA'], fontSize: '2.1vh'}}>End-Users</Text></Content>}/>
          <Link href='#TeamWL' title={<Content className='ContentAnchor' style={{borderColor: backIII}}><Text style={{color: appColors['ColorA'], fontSize: '2.1vh'}}>Distribution</Text></Content>}/>
          <Link href='#TeamDL' title={<Content className='ContentAnchor' style={{borderColor: backIV}}><Text style={{color: appColors['ColorA'], fontSize: '2.1vh'}}>Approvals</Text></Content>}/>
          <Link href='#TeamHP' title={<Content className='ContentAnchor' style={{borderColor: backV}}><Text style={{color: appColors['ColorA'], fontSize: '2.1vh'}}>Safety</Text></Content>}/>
          <Link href='#TeamC' title={<Content className='ContentAnchor' style={{borderColor: backVI}}><Text style={{color: appColors['ColorA'], fontSize: '2.1vh'}}>User Manual</Text></Content>}/>
          <Link href='#TeamEdu' title={<Content className='ContentAnchor' style={{borderColor: backVII}}><Text style={{color: appColors['ColorA'], fontSize: '2.1vh'}}>Challenges</Text></Content>}/>
          <Link href='#TeamEntre' title={<Content className='ContentAnchor' style={{borderColor: backVIII}}><Text style={{color: appColors['ColorA'], fontSize: '2.1vh'}}>Next Steps</Text></Content>}/>
          <Link href='#2' title={<Content className='ContentAnchor' style={{borderColor: backIX}}><Text style={{color: appColors['ColorA'], fontSize: '2.1vh'}}>Conclusion</Text></Content>}/>
          <Link href='#3' title={<Content className='ContentAnchor' style={{borderColor: backX}}><Text style={{color: appColors['ColorA'], fontSize: '2.1vh'}}>References</Text></Content>}/>
        </Anchor>
        <p style={{color: appColors['ColorA'], pointerEvents: 'none', fontSize: '2vh', top: '65vh', left: '5vh', textAlign: 'center', position: 'sticky'}}></p>
      </Sider>
      <Layout style={{margin: '1% 1% 0 1%', width: 'fit-content'}}>
        <Layout style={{background: appColors['ColorX'], height: '1px'}} />
        <Layout className='PurpBack' style={{background: appColors['ColorG']}}>
          <Layout style={{margin: '0 0 0 0', background: 'transparent'}}>
            <div id='TeamAdvisors'>
              <Introduction/>
            </div>
            <div id='TeamLeadership'>
              <Endusers/>
            </div>
            <div id='TeamWL'>
              <Distribution/>
            </div>
            <div id='TeamDL'>
              <Approvals/>
            </div>
            <div id='TeamHP'>
              <Safety/>
            </div>
            <div id='TeamC'>
              <UserManual/>
            </div>
            <div id='TeamEdu'>
              <Challenges/>
            </div>
            <div id='TeamEntre'>
              <NextSteps/>
            </div>
            <div id='2'>
              <Conclusions/>
            </div>
            <div id='3'>
              <References/>
            </div>
          </Layout>
        </Layout>
      </Layout>
    </Layout>
  );
};

export default ImplementationLogic;
